// Copied from blitz's bundled next/stdlib/zod-utils (importing anything from
// "blitz" client-side pulls in its next/stdlib fork, which no longer resolves
// once a real next@14 is installed alongside it).
export function formatZodError(error: any) {
  if (!error || typeof error.format !== "function") {
    throw new Error("The argument to formatZodError must be a zod error with error.format()")
  }
  const errors = error.format()
  return recursiveFormatZodErrors(errors)
}

function recursiveFormatZodErrors(errors: any): any {
  let formattedErrors: any = {}
  for (const key in errors) {
    if (key === "_errors") {
      continue
    }
    if (errors[key]?._errors?.[0]) {
      if (!isNaN(key as any) && !Array.isArray(formattedErrors)) {
        formattedErrors = []
      }
      formattedErrors[key] = errors[key]._errors[0]
    } else {
      if (!isNaN(key as any) && !Array.isArray(formattedErrors)) {
        formattedErrors = []
      }
      formattedErrors[key] = recursiveFormatZodErrors(errors[key])
    }
  }
  return formattedErrors
}
